import { faSignal, faSignalFair, faSignalGood, faSignalStrong, faSignalWeak } from "@fortawesome/pro-duotone-svg-icons";

export enum SimilarityTypes {
    EXACT_WORD = "exact_word",
    CLOSE_MATCH = "close_match",
    VERY_SIMILAR = "very_similar",
    SIMILAR = "similar",
    APPROXIMATE = "approximate",
    CUSTOM = "custom",
}
export enum SimilarityValues {
    EXACT_WORD = 100,
    CLOSE_MATCH = 95,
    VERY_SIMILAR = 90,
    SIMILAR = 85,
    APPROXIMATE = 80,
    CUSTOM = 0,
}

export const SIMILARITY_ITEMS = [
    {
        type: SimilarityTypes.EXACT_WORD,
        icon: faSignal,
        value: SimilarityValues.EXACT_WORD,
        label: "Exact Match",
    },
    {
        type: SimilarityTypes.CLOSE_MATCH,
        icon: faSignalStrong,
        value: SimilarityValues.CLOSE_MATCH,
        label: "Close Match",
    },
    {
        type: SimilarityTypes.VERY_SIMILAR,
        icon: faSignalGood,
        value: SimilarityValues.VERY_SIMILAR,
        label: "Very Similar",
    },
    {
        type: SimilarityTypes.SIMILAR,
        icon: faSignalFair,
        value: SimilarityValues.SIMILAR,
        label: "Similar",
    },
    {
        type: SimilarityTypes.APPROXIMATE,
        icon: faSignalWeak,
        value: SimilarityValues.APPROXIMATE,
        label: "Approximate",
    },
    {
        type: SimilarityTypes.CUSTOM,
        icon: faSignalWeak,
        value: SimilarityValues.CUSTOM,
        label: "Custom",
    },
];
